import React from "react";

import useDocumentTitle from "hooks/documentTitle";
import useMetaDescription from "hooks/metaDescription";
import PageWrapper from "components/layout/PageWrapper";
import Row from "components/layout/Row";
import Column from "components/layout/Column";
import PageHeader from "components/layout/PageHeader";
import TextBlock from "components/layout/TextBlock";
import useMetaKeywords from "hooks/metaKeywords";



const TermsAndConditionsPage = () => {
  useDocumentTitle("OJO terms and conditions");
  useMetaDescription("OJO provides personalized guidance for the home journey.");
  useMetaKeywords("OJO");
  
  return (
    <>
      <PageWrapper backgroundColor="white">
        <PageHeader
          title="OJO Terms of Service"
          supertext="Last updated: May 3, 2019"
        />
        <TextBlock>
          OJO is on a mission to empower people to make better decisions through
          the fusion of machine and human intelligence. Our unique, patented AI
          technology products can conduct text conversations with consumers at
          scale. By combining natural language understanding with data and
          personalization, our products allow for consumers to deeply engage in
          a purchase process prior to interacting with a salesperson.
          <br />
          <br />
          In these OJO terms of service, “we”, “us”, “our”, “OJO” or “OJO Labs”
          refers to OJO Labs Inc., 1007 S Congress, Building 9, Suite 400,
          Austin, Texas 78704, and the terms “you”, “your” and “user” will refer
          to you. When referring to the “OJO services,” we mean to include, both
          our phone-based and text-based services (the “OJO mobile services”)
          and our website and web app based services (the “OJO web app”) and
          also various websites, applications, web applications, text messages,
          email notifications and other mediums, or portions of such mediums,
          provided by OJO.
          <br />
          <br />
          You agree to our Terms by using the OJO services. By using the OJO
          services, you accept and agree to these Terms. If you are using the
          OJO services on behalf of an organization, then you are agreeing to
          these Terms for that organization and promising to OJO that you have
          the authority to bind that organization to these Terms (and, in which
          case, the terms “you” and “your” or “user” will refer to that
          organization). The exception to this is if that organization has a
          separate written agreement with OJO covering the use of the OJO
          services, in which case, if there are any provisions in these Terms
          that conflicts with that agreement, that agreement will govern such
          use.
          <br />
          <br />
          Whether using the OJO services as an individual or on behalf of an
          organization, you acknowledge that our agreements contained in these
          Terms are supported by reasonable and valuable consideration,
          including, without limitation, your ability to visit, use, submit
          information to, or receive information from the OJO services, the
          receipt and adequacy of which is hereby acknowledged by you
          individually and on behalf of any organization you represent. You also
          represent that you have the capacity to be bound by our agreements
          contained in these Terms, or if you are acting on behalf of a company
          or other entity, you have the authority to bind such company or
          entity.
          <br />
          <br />
          By using the OJO services, you agree to receive phone calls and text
          messages from us and our partners. By using the OJO services, you
          expressly authorize OJO, its affiliated companies and its partners
          (described below) and each such entity’s employees, contractors and
          software (collectively, “Service Provider”) to communicate with you by
          phone and text at the wireless phone number provided or any other
          number that you may provide in the future. You understand that message
          and data rates may apply based upon the terms of your wireless service
          provider contract. You also agree that methods of contact may include
          use of auto-generated text messages or an automated telephone dialing
          system, even if you’ve registered that number on a Do-Not-Call
          registry, and that my consent to text messages and phone calls is not
          a condition to using any Service Provider’s services. If you do not
          consent to receive these texts or calls, do not use the OJO service or
          provide your information to us.
          <br />
          <br />
          You agree to indemnify Service Provider in full for all claims,
          expenses, and damages related to or caused in whole or in part by your
          failure to notify Service Provider if you change your wireless phone
          number, including but not limited to all claims, expenses, and damages
          related to or arising under the Telephone Consumer Protection Act
          (TCPA). You agree to notify Service Provider promptly if you change
          your wireless telephone number. You may revoke your consent to receive
          (i) phone calls by requesting to be placed on an internal Do Not Call
          list and (ii) text messages by responding to a text message with STOP.
          You understand this authorization cannot be revoked to the extent that
          action has already been taken in reliance on this authorization prior
          to the date Service Provider receives my request to revoke
          authorization.
          <br />
          <br />
          Our partners include (i) real estate brokers, including Realogy
          Holdings Corporation, Realogy Group LLC and their subsidiaries,
          affiliates and franchisees (including Realogy Services Group LLC, NRT
          LLC and franchisees operating under the Century 21, Coldwell Banker,
          Coldwell Banker Commercial, ERA, Sotheby’s International Realty, and
          Better Homes and Gardens Real Estate brands); (ii) mortgage lead
          aggregators, including Bankrate, LLC and its parent, subsidiary and
          affiliated companies (including BR Tech Services, LLC); and (iii) in
          Canada, Royal Bank of Canada and its affiliated companies and real
          estate brokers, including Royal LePage Real Estate Services, a
          division of Brookfield Real Estate Services Manager Limited, or to the
          following independently owned and operated franchise locations: Royal
          LePage Burloak Real Estate Services, Royal LePage Estate Realty, Royal
          LePage Meadowtowne Realty, Royal LePage Wolle Realty, Royal LePage
          Your Community Realty.
          <br />
          <br />
          In the event of a dispute between us, we agree to binding arbitration.
          These Terms contain a binding arbitration agreement, which provides
          that you and OJO agree to resolve certain disputes through binding
          individual arbitration and give up any right to have those disputes
          decided by a judge or a jury. You have the right to opt out of our
          agreement to arbitrate. See the Legal Disputes section below.
          <br />
          <br />
          The OJO services are not intended for minors and are only for citizens
          and residents of the United States and Canada. The OJO services are
          intended to be accessed and used only by adults and are not directed
          to minors. As stated in our Privacy Policy, we do not knowingly
          collect personal identifiable information from anyone under the age of
          13 and you should not provide us with any information regarding any
          individual under the age of 13. The OJO services are also only to be
          used by citizens and residents of the United States and Canada. No
          other persons are authorized to use the OJO services, including,
          without limitation, residents and citizens of the European Union (EU).
          <br />
          <br />
          PLEASE REVIEW THESE TERMS CAREFULLY. ONCE ACCEPTED BY YOUR USE OF THE
          OJO SERVICES, THESE TERMS BECOME A BINDING LEGAL COMMITMENT BETWEEN
          YOU AND OJO. IF YOU DO NOT AGREE TO BE BOUND BY THESE TERMS, YOU
          SHOULD NOT TEXT OR EMAIL WITH THE OJO SERVICES AND YOU SHOULD NOT USE
          THE OJO SERVICES.
        </TextBlock>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              <strong>We may change our terms.</strong>
              <br />
              <br />
              If we do, we will notify you here or via text or email.
              <br />
              <br />
              If you keep using our services after the terms change, then you
              have accepted those changes.
            </TextBlock>
          </Column>
          <Column size={8}>
            We may revise these OJO terms of service from time to time. If we
            do, our revised terms will supersede prior versions. Unless we
            provide otherwise, revisions will be effective on and after the date
            at the top of the revised terms. If we make any material changes to
            our terms of service, we will provide notice to you either here, via
            the OJO app or via text or phone. For non-material changes, we will
            update the effective date of our terms of service at the top of this
            page. We encourage you to check the effective date of these terms of
            service whenever you visit our website, or use the OJO mobile
            services OJO app. Your continued access or use of the OJO services
            constitutes your acceptance of any and all changes, whether material
            or non-material. If you do not agree to the changes, you should stop
            using the OJO services
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              <strong>Your use of the OJO services.</strong>
              <br />
              <br />
              If you want to use the OJO services, you need to give us some
              information about yourself. The information you provide to us must
              be true and kept up to date
            </TextBlock>
          </Column>
          <Column size={8}>
            In order to use the OJO services, you will be asked to provide your
            mobile phone number and provide consent for us to contact you via
            voice call and/or text message, including through the use of
            automated calling technology, even if you’ve registered that number
            on a Do-Not-Call registry. We may also ask you to provide other
            information such as your e-mail address or current physical address.
            You must provide true, accurate, current and complete information
            about yourself as requested during the user onboarding process. You
            must keep that information true, accurate, current and complete
            after your initial use of the OJO services.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              Your right to use our services is personal to you and cannot be
              transferred.
            </TextBlock>
          </Column>
          <Column size={8}>
            Your right to access and use the OJO services is personal to you and
            is not transferable by you to any other person or entity. You are
            only entitled to access and use the OJO services for lawful purposes
            and pursuant to these Terms and our Privacy Policy.
            <br />
            <br />
            You are solely responsible for all use (whether or not authorized)
            of the OJO services related to your mobile phone number, including
            the quality and integrity of your User Data. You are also solely
            responsible for all acts and omissions of anyone who has access to
            or otherwise uses your mobile phone number (“end users”). You agree
            to take all reasonable precautions to prevent unauthorized access to
            or use of the OJO services and will notify us promptly of any
            unauthorized access or use. We will not be liable for any loss or
            damage arising from unauthorized use of the OJO services via your
            mobile phone number. You also agree not to allow any person under
            the age of 18 to use the OJO services via your mobile phone number.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              OJO makes no guarantees regarding availability of the OJO
              services.
            </TextBlock>
          </Column>
          <Column size={8}>
            We will strive to make the OJO services available to you, but we
            make no guarantees regarding the availability of the OJO services,
            generally or at any particular time.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              You may use the OJO services solely in accordance with these terms
              of service.
            </TextBlock>
          </Column>
          <Column size={8}>
            You may use the OJO services, on a non-exclusive basis, solely in
            connection with and as necessary for your activities pursuant to
            these Terms. Any action by you that, in our sole discretion: (i)
            violates our Terms and/or our Privacy Policy; (ii) restricts,
            inhibits or prevents any access, use or enjoyment of the OJO
            services; or (iii) through the use of the OJO services, defames,
            abuses, harasses, offends or threatens, shall not be permitted, and
            may result in your loss of the right to access and use the OJO
            services. You shall not modify, scrape, embed, or frame the OJO
            services without our prior written permission.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              OJO may discontinue providing the OJO services to any particular
              user, group of users or all users.
            </TextBlock>
          </Column>
          <Column size={8}>
            OJO reserves the right to cease providing or discontinue the OJO
            services to any particular user, any group of users or all users, in
            its sole and complete discretion and without prior notice.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              <strong>Offers from our service partners and affiliates.</strong>
              <br />
              <br />
              Through the OJO service, you may choose to connect to third-party
              service providers.
              <br />
              <br />
              OJO does not endorse any third-party service providers.
              <br />
              <br />
              You should investigate any third-party service providers
              thoroughly and OJO is not responsible for any service provider.
            </TextBlock>
          </Column>
          <Column size={8}>
            Through the OJO services, OJO and our partners and affiliates may
            provide a venue through which you can obtain information regarding
            residential real estate and you can, upon your request, be connected
            to third-party service providers, such as real estate brokers,
            mortgage information services, insurance brokers, and other
            companies providing services around the buying and selling of real
            estate (“service providers”). We do not endorse or recommend the
            products or services of any service provider and are not an agent or
            advisor to you or any service provider. We do not validate or
            investigate the licensing, certification or other requirements and
            qualifications of service providers. It is your responsibility to
            investigate any service providers before you engage them. You
            acknowledge and agree that these service providers are solely
            responsible for any services that they may provide to you and that
            we are not liable for any losses, costs, damages or claims in
            connection with, arising from, or related to, your use of a service
            provider’s products or services. We urge you to obtain the advice of
            financial advisors or other qualified professionals who are fully
            aware of your individual circumstances before you make any financial
            decisions. You acknowledge and agree that you rely on your own
            judgment and that of such advisors in selecting any products or
            services offered by service providers.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              OJO is not a lending institution or other service provider.
            </TextBlock>
          </Column>
          <Column size={8}>
            OJO is not a real estate agent or lending institution or other
            service provider. Instead, we, through the OJO services, may help to
            connect you with service providers that might meet your needs based
            on information provided by you. OJO does not, and will not, make any
            credit decision with any service provider referred to you. OJO does
            not issue mortgages or any other financial products.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              Unless you are a service provider, OJO does not charge for its
              services.
            </TextBlock>
          </Column>
          <Column size={8}>
            Unless you are a service provider, we do not charge you a fee to use
            our OJO services. Service providers may pay us fees for services and
            to be matched with users of the OJO services, however. OJO is not
            involved with and is not responsible for any fee arrangement that
            you may enter into with any service provider.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              You release OJO from liability for your use of a service provider.
            </TextBlock>
          </Column>
          <Column size={8}>
            By using the OJO services, you hereby release us of any and all
            losses, costs, damages or claims in connection with, arising from or
            related to your use of a service provider’s products or services,
            including any fees charged by a service provider.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              <strong>Information you provide to OJO</strong>
            </TextBlock>
          </Column>
          <Column size={8}>
            <TextBlock>
              If you transmit, submit or post information to the OJO services
              that is not federally trademarked and/or copyrighted, you
              automatically grant us and our assigns the worldwide, fully-paid,
              royalty-free, exclusive right and license to use, copy, format,
              adapt, publish and/or incorporate any or all such information in
              any media whatsoever, including, without limitation, the Content
              (as defined below). If you have obtained prior written permission
              from us to transmit, submit or post information to our Services
              that is federally trademarked and/or copyrighted, you
              automatically grant us and our assigns the worldwide, fully-paid,
              royalty-free right to use, copy, format, adapt, publish and/or
              incorporate any or all such information in any media whatsoever,
              including, without limitation, the OJO content.
              <br />
              <br />
              You shall not transmit, submit or post the following to the OJO
              services:
              <br />
              <br />
              <ul>
                <li>
                  Information that infringes our or any third party’s copyright,
                  patent, trademark, trade secret or other proprietary rights;
                </li>
                <li>
                  Information that violates any law, statute, ordinance or
                  regulation;
                </li>
                <li>
                  Information that is trade libelous, unlawfully threatening,
                  unlawfully harassing, defamatory, obscene, explicit or vulgar,
                  or otherwise injurious to us or third parties or that
                  infringes on our or any third party’s rights of publicity or
                  privacy;
                </li>
                <li>
                  Information that contains any viruses, worms, Trojan horses,
                  trap doors, back doors, easter eggs, time bombs, cancelbots or
                  other code or computer programming routines that contain
                  contaminating or destructive properties or that are intended
                  to damage, detrimentally interfere with, surreptitiously
                  intercept or expropriate any system, data or personal
                  information;
                </li>
                <li>
                  Information containing or constituting chain letters, mass
                  mailings, political campaigning, or any form of “spam”;
                </li>
                <li>Information that is false, inaccurate or misleading;</li>
                <li>
                  Commercial advertisements or solicitations without our written
                  permission; or
                </li>
                <li>
                  Federally trademarked and/or copyrighted information without
                  our prior written permission.
                </li>
              </ul>
              <br />
              <br />
              We reserve the right (but not the obligation) to edit, refuse to
              post or remove your transmissions, submissions or postings. Under
              our Privacy Policy, we may review transmissions, submissions or
              postings made by you to determine, in our sole discretion, your
              compliance with these Terms.
              <br />
              <br />
              You are solely responsible for all your transmissions, submissions
              or postings (i.e., your own user data) and the consequences of
              transmitting, submitting or posting them.
            </TextBlock>
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              <strong>OJO’s use of your data.</strong>
              <br />
              <br />
              Please read our privacy policy to understand what we do with your
              data. If you don’t want your data used that way, stop using our
              services immediately and unsubscribe from the OJO mobile services
              and web app by texting “STOP” to us.
            </TextBlock>
          </Column>
          <Column size={8}>
            “user data” consists of data and other information made available to
            us through the use of the OJO services under these terms of service,
            including, user usage data and user content.
            <br />
            <br />
            “user usage data” shall mean communications metadata made available
            to us through the use of the OJO services and include, without
            limitation, data used to trace and identify the source and
            destination of a communication, such as individual data subjects’
            telephone numbers, data on the location of the device generated in
            the context of providing the OJO services, and the date, time,
            duration, and type of communication.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              We might have to use or disclose your data for one or more of the
              reasons below:
              <br />
              <br />
              <ul>
                <li>If necessary to provide you with the OJO services;</li>
                <li>
                  To address technical issues, provide support or maintain our
                  services;
                </li>
                <li>
                  If we need to protect OJO labs, other users, or the public;
                </li>
                <li>If there is an emergency; or</li>
                <li>If the law requires.</li>
              </ul>
            </TextBlock>
          </Column>
          <Column size={8}>
            “user content” shall mean content exchanged by means of use of the
            OJO services, such as text message bodies, voice and video media,
            images, sound, and other content.
            <br />
            <br />
            You acknowledge that you have read our Privacy Policy and understand
            that it sets forth how we will collect, store, and use your user
            data. If you do not agree with our Privacy Policy, stop using the
            OJO services immediately.
            <br />
            <br />
            You instruct us to use and disclose user data as necessary to (a)
            provide the OJO services consistent with our Privacy Policy and
            these terms of service, including detecting, preventing, and
            investigating security incidents, fraud or unlawful use of the OJO
            services; (b) respond to any technical problems or user queries and
            ensure the proper working of the OJO services; (c) to protect
            ourselves, our other customers, the public from harm or illegal
            activities, or the OJO services; (d) to respond to an emergency
            which we believe in, good faith, requires us to disclose user data
            to assist in preventing a death or serious bodily injury; or (e)
            comply with any applicable Law, regulation, legal process or
            government request.
            <br />
            <br />
            “Law” means any statute, law, ordinance, regulation, rule, judgment
            or order of a government, court, or tribunal of competent
            jurisdiction, including, without limitation, any data protection
            laws, privacy laws, any laws that requires you to obtain consent
            from a user or provide notice to a user in connection with such
            User’s use of any of the OJO services, any state, federal, and
            international laws, regulations, and rules related to the recording
            or monitoring of telephone calls, SMS messages, or other
            communications, the U.S. Foreign Corrupt Practices Act, rules
            established by the Federal Communications Commission, any federal or
            state anti-spam statute or regulation, including the CAN SPAM Act of
            2003, or any federal or state statute or regulation prohibiting the
            dissemination of unsolicited communications, including the Telephone
            Consumer Protection Act of 1991 (TCPA).
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              <strong>Restrictions and Requirements</strong>
              <br />
              <br />
              Don’t transfer our services or resell them.
              <br />
              <br />
              Don’t use our services to break the laws, regulations, rules,
              etc., to violate these terms, or to violate someone else’s rights;
              <br />
              <br />
              Do make sure that OJO is allowed to use your data as needed to
              provide you our services; and
              <br />
              <br />
              Don’t reverse engineer any software we provide
            </TextBlock>
          </Column>
          <Column size={8}>
            <TextBlock>
              If you use the OJO services, you must comply with the following
              restrictions and requirements:
              <br />
              <br />
              <ul>
                <li>
                  you agree not to transfer, resell, lease, license or otherwise
                  make available the OJO services to third parties or offer them
                  on a standalone basis;
                </li>
                <li>
                  you will ensure that the OJO services are used in accordance
                  with all applicable Law and third party rights, as well as
                  these Terms;
                </li>
                <li>
                  you will ensure that we are entitled to use your User Data, as
                  needed to provide the OJO services;
                </li>
                <li>
                  you will not use the OJO services in any manner that violates
                  any applicable Law; and
                </li>
                <li>
                  except as allowed by applicable Law, you will not reverse
                  engineer, decompile, disassemble or otherwise create, attempt
                  to create or derive, or permit or assist anyone else to create
                  or derive the source code of any software provided in
                  connection with the OJO services
                </li>
              </ul>
            </TextBlock>
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              <strong>Referral Partners</strong>
              <br />
              <br />
              While you are using the OJO services, we may share with you
              opportunities offered by our network of referral partners. We are
              typically compensated by our referral partners for referrals made
              to them.
              <br />
              <br />
              Products or services that you may purchase from our Referral
              Partners are not OJO products or services, but, instead, are being
              offered by third parties.
              <br />
              <br />
              When you accept a referral to one of our Referral Partners, you
              are telling OJO that it’s okay for us to give the Referral Partner
              information about you so that they can offer their products or
              services to you.
            </TextBlock>
          </Column>
          <Column size={8}>
            We may make available through the OJO services referrals to our
            third-party partners who may offer to provide additional products
            and services to you (each, a “Referral Partner"). We are typically
            compensated by our Referral Partners for such referrals. If you, at
            your sole discretion, choose to engage with a Referral Partner, then
            you will be required to accept the Referral Provider’s terms of
            service (“Referral Provider’s Terms”) as part of the referral
            process. The Referral Provider is solely responsible for their
            products or services offered, the content therein, and any claims
            that you or any other party may have relating to the Referral
            Partner’s products and services.
            <br />
            <br />
            When you accept a referral to one of our Referral Partners, you
            acknowledge that you are purchasing any products or services offered
            by the Referral Partner directly from them and that OJO is not a
            party to any agreement between you and the Referral Partner with
            respect to those products and services; and OJO is not responsible
            for that Referral Partner’s products or services, the content
            therein, or any claims that you or any other party may have relating
            to that Referral Partner’s products and services.
            <br />
            <br />
            By accepting a referral to one of our Referral Partners, you grant
            us permission to share your User Data with the Referral Partner so
            that they may offer their products or services to you.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              <strong>Ownership and Confidentiality</strong>
              <br />
              <br />
              What’s ours is ours, and what’s yours is yours.
              <br />
              <br />
              Please let us know what you think about our services. If you send
              us feedback, we can use it and we don’t owe you anything for it.
              <br />
              <br />
              We both agree not to tell anyone else about confidential
              information that we get from each other. Also, we both agree to
              only use each other’s confidential information as agreed to in
              these terms.
            </TextBlock>
          </Column>
          <Column size={8}>
            <TextBlock>
              As between you and OJO, we exclusively own and reserve all right,
              title and interest in and to the OJO services and our Confidential
              Information. As between you and OJO, you exclusively own and
              reserve all right, title and interest in and to your Confidential
              Information.
              <br />
              <br />
              We also welcome your feedback about the OJO services. But please
              know that by submitting suggestions or other feedback about the
              OJO services (“Suggestions”) you agree that:
              <br />
              <br />
              <ul>
                <li>
                  we are not under any obligation of confidentiality with
                  respect to your Suggestions
                </li>
                <li>
                  we may use or disclose (or choose not to use or disclose) your
                  Suggestions for any purpose and in any way;
                </li>
                <li>
                  you irrevocably, non-exclusively license to us rights to
                  exploit your Suggestions; and
                </li>
                <li>
                  you are not entitled to any compensation or reimbursement of
                  any kind from us under any circumstances for your Suggestions.
                </li>
              </ul>
              <br />
              <br />
              "Confidential Information" means any information or data,
              regardless of whether it is in tangible form, disclosed by either
              party that is marked or otherwise designated as confidential or
              proprietary or that should otherwise be reasonably understood to
              be confidential given the nature of the information and the
              circumstances surrounding disclosure. Confidential Information
              does not include any information which: (a) is publicly available
              through no fault of the receiving party; (b) was properly known to
              the receiving party, without restriction, prior to disclosure by
              the disclosing party; (c) was properly disclosed to the receiving
              party, without restriction, by another person without violation of
              the disclosing party's rights; or (d) is independently developed
              by the receiving party without use of or reference to the
              Confidential Information of the disclosing party.
            </TextBlock>
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              Money alone may not be enough to make either of us whole if one of
              us breaks our promise of confidentiality. So, we both can seek
              other remedies, if needed.
            </TextBlock>
          </Column>
          <Column size={8}>
            The receiving party agrees that it will use the Confidential
            Information of the disclosing party solely in accordance with these
            Terms and it will not disclose such Confidential Information to any
            third party without the disclosing party's prior written consent,
            except as otherwise permitted hereunder; provided, however, OJO may
            use and disclose your Confidential Information as necessary to
            provide the OJO services, including making referrals to our Referral
            Partners. The receiving party agrees to exercise due care in
            protecting Confidential Information of the disclosing party from
            unauthorized use and disclosure. The receiving party may disclose
            the Confidential Information of the disclosing party, in whole or in
            part to its employees, representatives, actual or potential
            investors, and subcontractors who have a need to know and are
            legally bound to keep such information confidential consistent with
            the terms of this provision. The receiving party may disclose the
            Confidential Information of the disclosing party as required by
            applicable Law provided that, prior to any such compelled
            disclosure, the receiving party will, if permissible: (a) promptly
            notify the disclosing party in writing to allow the disclosing party
            a reasonable opportunity to resist such disclosure and/or seek a
            protective order, and (b) reasonably cooperate with the disclosing
            party in protecting against any such disclosure and/or obtaining a
            protective order narrowing the scope of such disclosure. In the
            event that such protection against disclosure is not obtained, the
            receiving party will be entitled to disclose the Confidential
            Information of the disclosing party, but only as and to the extent
            necessary to legally comply with such compelled disclosure. The
            parties expressly acknowledge and agree that no adequate remedy may
            exist at law for an actual or threatened breach of this provision
            and that, in the event of an actual or threatened breach of the
            provisions of this provision, the non-breaching party will be
            entitled to seek immediate injunctive and other equitable relief,
            without waiving any other rights or remedies available to it. Each
            party will promptly notify the other in writing if it becomes aware
            of any violations of the confidentiality obligations set forth in
            this provision.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              <strong>Warranty Disclaimer</strong>
              <br />
              <br />
              We are offering the OJO services “as is” and make no
              representations and warranties regarding the OJO services.
            </TextBlock>
          </Column>
          <Column size={8}>
            WE HEREBY DISCLAIM ANY AND ALL WARRANTIES, EXPRESS OR IMPLIED,
            INCLUDING, BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY,
            NON-INFRINGEMENT, AND FITNESS FOR A PARTICULAR PURPOSE AND
            WARRANTIES RELATED TO THIRD-PARTY EQUIPMENT, MATERIAL, SERVICES, OR
            SOFTWARE. THE OJO SERVICES ARE PROVIDED “AS IS” TO THE FULLEST
            EXTENT PERMITTED BY LAW. TO THE EXTENT SUCH DISCLAIMER CONFLICTS
            WITH APPLICABLE LAW, THE SCOPE AND DURATION OF ANY APPLICABLE
            WARRANTY WILL BE THE MINIMUM PERMITTED UNDER SUCH LAW.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              <strong>Indemnification</strong>
              <br />
              <br />
              OJO will not pay for any bills, damages, costs, etc. for any claim
              by you that arises from your use of our services.
              <br />
              <br />
              You agree to indemnify OJO against all claims relating to your use
              of the OJO services
            </TextBlock>
          </Column>
          <Column size={8}>
            OJO will have no liability or obligation with respect to any claims,
            demands, actions, suits, discovery demands, including, without
            limitation, third party subpoenas, government investigations or
            enforcement actions (“Claim”) and any damages, liabilities, losses,
            settlements, judgments, costs and expenses (including, without
            limitation, reasonable attorney’s fees and costs) (“Losses”) related
            thereto arising out of your use of the OJO services.
            <br />
            <br />
            You will defend, indemnify and hold OJO, its officers, directors,
            employees, agents, stockholders, and affiliates (“OJO Indemnified
            Parties”) harmless from and against all Claims brought or threatened
            by a third party against an OJO Indemnified Party and any Losses
            related thereto alleging or arising out of your breach of or
            activities under these Terms or your use of the OJO services.
            <br />
            <br />
            As a condition of your foregoing indemnification obligations: (a)
            OJO will promptly notify you of any Claim, provided, however, that
            the failure to give such notice shall not relieve you of your
            obligations hereunder except to the extent that you are actually and
            materially prejudiced by such failure; (b) you will have the sole
            and exclusive authority to defend or settle any such Claim (provided
            that, you will obtain OJO’s consent in connection with any act or
            forbearance required by OJO, which consent will not be unreasonably
            withheld); and (c) OJO will reasonably cooperate with you in
            connection with your activities hereunder, at your sole expense. You
            reserve the right, at your own expense, to participate in the
            defense of a Claim. You, in connection with a Claim, will pay all
            Losses following notice of the Claim. Notwithstanding anything
            herein to the contrary, you will not settle any Claims for which you
            have an obligation to indemnify admitting liability or fault on
            behalf of OJO, nor create any obligation on behalf of OJO without
            OJO’s prior written consent.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              <strong>Limitation of Liability</strong>
            </TextBlock>
          </Column>
          <Column size={8}>
            INDIRECT DAMAGES. UNDER NO CIRCUMSTANCES AND UNDER NO LEGAL THEORY,
            WHETHER IN TORT, CONTRACT, OR OTHERWISE, WILL EITHER PARTY BE LIABLE
            TO THE OTHER PARTY FOR ANY INDIRECT, SPECIAL, INCIDENTAL,
            CONSEQUENTIAL OR PUNITIVE DAMAGES OF ANY CHARACTER, INCLUDING,
            WITHOUT LIMITATION, DAMAGES FOR LOSS OF GOODWILL, LOST PROFITS, LOST
            SALES OR BUSINESS, WORK STOPPAGE, COMPUTER FAILURE OR MALFUNCTION,
            LOST DATA, OR FOR ANY AND ALL OTHER DAMAGES OR LOSSES, EVEN IF A
            PARTY HAD BEEN ADVISED, KNEW OR SHOULD HAVE KNOWN OF THE POSSIBILITY
            OF SUCH DAMAGES. THIS SECTION SHALL NOT LIMIT (A) YOUR LIABILITY
            ARISING FROM YOUR BREACH OF THE RESTRICTIONS AND REQUIREMENTS
            SECTION ABOVE; (B) EITHER PARTY’S LIABILITY ARISING FROM SUCH
            PARTY’S BREACH OF THE CONFIDENTIALITY SECTION ABOVE; OR (C) EITHER
            PARTY’S INDEMNIFICATION OBLIGATIONS PURSUANT TO THESE TERMS.
            <br />
            <br />
            DIRECT DAMAGES. UNDER NO CIRCUMSTANCES AND UNDER NO LEGAL THEORY,
            WHETHER IN TORT, CONTRACT, OR OTHERWISE, WILL EITHER PARTY BE LIABLE
            TO THE OTHER PARTY FOR ANY DIRECT DAMAGES, COSTS OR LIABILITIES IN
            EXCESS OF THE AMOUNTS PAID OR PAYABLE BY YOU DURING THE TWELVE (12)
            MONTHS PRECEDING THE INCIDENT OR CLAIM. THIS SECTION SHALL NOT LIMIT
            (A) YOUR LIABILITY ARISING FROM YOUR BREACH OF SECTION 5
            (RESTRICTIONS AND REQUIREMENTS) OR SECTION 10 (FEES, PAYMENT TERMS,
            AND TAXES); OR (B) EITHER PARTY’S LIABILITY ARISING FROM SUCH
            PARTY’S BREACH OF SECTION 11.4 (CONFIDENTIALITY); OR (C) EITHER
            PARTY’S INDEMNIFICATION OBLIGATIONS PURSUANT TO THESE TERMS. THE
            PROVISIONS OF THIS SECTION 14 ALLOCATE THE RISKS PURSUANT TO THESE
            TERMS BETWEEN THE PARTIES, AND THE PARTIES HAVE RELIED ON THE
            LIMITATIONS SET FORTH HEREIN IN DETERMINING WHETHER TO ENTER INTO
            THESE TERMS.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              <strong>Term; Suspension</strong>
              <br />
              <br />
              These terms become effective on the first day that you either
              click “I Accept” or start using the OJO services.
            </TextBlock>
          </Column>
          <Column size={8}>
            These Terms, as may be updated from time to time, will commence on
            the date they are accepted by you either by clicking “I Accept” or
            your first use of the OJO services and continue until terminated as
            described below (“Term”).
            <br />
            <br />
            We may suspend the OJO services immediately upon notice for cause
            if: (a) you violate (or give us reason to believe you have violated)
            these Terms; (b) there is reason to believe the traffic created from
            your use of the OJO services or your use of the OJO services is
            fraudulent or negatively impacting the operating capability of the
            OJO services; (c) we determine, in our sole discretion, that
            providing the OJO services is prohibited by applicable Law, or it
            has become impractical or unfeasible for any legal or regulatory
            reason to provide the OJO services. If we suspend the OJO services,
            we will make a reasonable attempt to notify you prior to the
            suspension to the extent we can.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              <strong>General</strong>
            </TextBlock>
          </Column>
          <Column size={8}>
            <TextBlock>
              <strong>Compliance with Laws:</strong>
              <br />
              <br />
              Both you and OJO will comply with the applicable Law relating to
              each of our respective activities pursuant to these Terms.
              <br />
              <br />
              <span className="body bold">No Waiver:</span> Our failure to
              enforce at any time any provision of these Terms does not waive
              our right to do so later. And, if we do expressly waive any
              provision of these Terms, that does not mean it is waived for all
              time in the future. Any waiver must be in writing and signed by
              you and us to be legally binding.
              <br />
              <br />
              <span className="body bold">Assignment:</span> You will not assign
              or otherwise transfer these Terms, in whole or in part, without
              our prior written consent. Any attempt by you to assign, delegate,
              or transfer these Terms will be null and void. Subject to this
              Assignment section, these Terms will be binding on both you and
              OJO and each of our successors and assigns.
              <br />
              <br />
              <span className="body bold">Unenforceability:</span> Except as
              described in the Agreement to Arbitrate section, if any provision
              of these Terms is held by a court or other tribunal of competent
              jurisdiction to be unenforceable, that provision will be limited
              or eliminated to the minimum extent necessary to make it
              enforceable and, in any event, the rest of these Terms will
              continue in full force and effect.
              <br />
              <br />
              <span className="body bold">Notices:</span> Any notice required or
              permitted to be given under these Terms will be given in writing
              to the receiving party by personal delivery, certified mail,
              return receipt requested, overnight delivery by a nationally
              recognized carrier or by email upon confirmation of receipt.
              Notices to OJO shall be copied to{" "}
              <span className="highlight">legal@ojolabs.com</span>,
              Attn: General Counsel.
              <br />
              <br />
              <span className="body bold">Entire Agreement:</span> Except as
              provided in these Terms and any attachments to these Terms, these
              Terms supersede all prior and contemporaneous proposals,
              statements, marketing materials or presentations and agreements,
              oral and written. No oral or written information or advice given
              by OJO, its agents or employees will create a warranty or in any
              way increase the scope of the warranties in these Terms. Any
              purchase order document or similar document provided by you shall
              be construed solely as evidence of your internal business
              processes, and the terms and conditions contained thereon shall be
              void and have no effect with regard to these Terms between you and
              OJO and be non-binding against OJO even if signed by OJO after the
              date you accept these Terms.
              <br />
              <br />
              <span className="body bold">Force Majeure:</span> No failure,
              delay or default in performance of any obligation of a party shall
              constitute an event of default or breach of these Terms to the
              extent that such failure to perform, delay or default arises out
              of a cause, existing or future, that is beyond the control and
              without negligence of such party, including action or inaction of
              governmental, civil or military authority; fire; strike, lockout
              or other labor dispute; flood, terrorist act; war; riot; theft;
              earthquake and other natural disaster. The party affected by such
              cause shall take all reasonable actions to minimize the
              consequences of any such cause.
              <br />
              <br />
              <span className="body bold">Governing Law and Venue:</span> The
              enforceability and interpretation of the Agreement to Arbitrate
              section below will be determined by the Federal Arbitration Act
              (including its procedural provisions). Apart from the arbitration
              provision, these Terms will be governed by and interpreted
              according to the laws of the State of Texas without regard to
              conflicts of laws and principles that would cause laws of another
              jurisdiction to apply. These Terms will not be governed by the
              United Nations Convention on Contracts for the International Sale
              of Goods. Except as provided in the Arbitration section below, any
              legal suit, action or proceeding arising out of or related to
              these Terms or the OJO services shall be instituted in either the
              state or federal courts of Austin, Texas, and we each consent to
              the personal jurisdiction of these courts.
            </TextBlock>
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              <strong>Agreement to Arbitrate</strong>
            </TextBlock>
          </Column>
          <Column size={8}>
            Before bringing a formal legal case, please first try contacting our
            Customer Support. Most disputes can be resolved that way.
            <br />
            <br />
            We Both Agree to Arbitrate: If a dispute cannot be resolved through
            our Customer Support team, you or any of your affiliates on one hand
            and OJO and any of OJO’s affiliates on the other hand, all agree to
            resolve any dispute relating to these Terms or in relation to the
            OJO services by binding arbitration in Austin, Texas, or in another
            location that we have both agreed to.
            <br />
            <br />
            This applies to all claims under any legal theory, unless the claim
            fits in one of the exceptions below in Exceptions to Agreement to
            Arbitrate. It also applies even after you have stopped using the OJO
            services. If we have a dispute about whether this agreement to
            arbitrate can be enforced or applies to our dispute, we all agree
            that the arbitrator will decide that, too.
            <br />
            <br />
            Pursuant to this Agreement to Arbitrate section, you understand that
            you and your affiliates and OJO and its affiliates are giving up the
            right to have a judge and/or jury resolve any controversy or claim
            arising out of or relating to these Terms or the OJO services.
            <br />
            <br />
            Exceptions to Agreement to Arbitrate: You and your affiliates on one
            hand, and OJO and its affiliates on the other hand, agree that we
            will go to court to resolve disputes relating to your, your
            affiliates’, OJO’s or OJO’s affiliates’ intellectual property (e.g.,
            trademarks, trade dress, domain names, trade secrets, copyrights or
            patents).
            <br />
            <br />
            In addition, if any of us brings a claim in court that should be
            arbitrated or any of us refuses to arbitrate a claim that should be
            arbitrated, the other of us can ask a court to force us to go to
            arbitration to resolve the claim (i.e., compel arbitration). Any of
            us may also ask a court to halt a court proceeding while an
            arbitration proceeding is ongoing.
            <br />
            <br />
            Details of Arbitration Procedure: Prior to filing any arbitration,
            both parties jointly agree to seek to resolve any dispute between us
            by mediation conducted by the American Arbitration Association
            (AAA), with all mediator fees and expenses paid equally by the
            parties. If mediation is not successful, either party may initiate
            an arbitration proceeding with AAA. You can look at AAA’s rules and
            procedures on their website [http://www.adr.org] or you can call
            them at 1-800-778-7879. The arbitration will be governed by the
            then-current version of AAA’s Commercial Arbitration Rules (the
            "Rules") and will be held with a single arbitrator appointed in
            accordance with the Rules. To the extent anything described in this
            Agreement to Arbitrate section conflicts with the Rules, the
            language of this Agreement to Arbitrate section applies. Each of us
            will be entitled to get a copy of non-privileged relevant documents
            in the possession or control of the other party and to take a
            reasonable number of depositions. All such discovery will be in
            accordance with procedures approved by the arbitrator. This
            Agreement to Arbitrate section does not alter in any way the statute
            of limitations that would apply to any claims or counterclaims
            asserted by either party. The arbitrator’s award will be based on
            the evidence admitted and the substantive law of the State of Texas
            and the United States, as applicable, and will contain an award for
            each issue and counterclaim. The award will provide in writing the
            factual findings and legal reasoning for such award. The arbitrator
            will not be entitled to modify these Terms. Except as provided in
            the Federal Arbitration Act, the arbitration award will be final and
            binding on the parties. Judgment may be entered in any court of
            competent jurisdiction.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              <strong>Class Action Waiver</strong>
            </TextBlock>
          </Column>
          <Column size={8}>
            Both you and your affiliates, on one hand, and OJO and its
            affiliates on the other hand, agree that any claims or controversies
            between us must be brought against each other on an individual basis
            only. That means neither you and your affiliates on one hand nor OJO
            and its affiliates on the other hand can bring a claim as a
            plaintiff or class member in a class action, consolidated action, or
            representative action. The arbitrator cannot combine more than one
            person’s or entity’s claims into a single case, and cannot preside
            over any consolidated, class or representative proceeding (unless we
            agree otherwise). And, the arbitrator’s decision or award in one
            person’s or entity’s case can only impact the person or entity that
            brought the claim, not other OJO customers, and cannot be used to
            decide other disputes with other customers. If a court decides that
            this Class Action Waiver provision is not enforceable or valid, then
            the entire Agreement to Arbitrate section will be null and void, but
            the rest of the Terms will still apply.
          </Column>
        </Row>
        <Row marginBottom={20}>
          <Column size={2}>
            <TextBlock featured>
              <strong>DMCA Agent</strong>
              <br />
              <br />
              Please contact our DMCA Agent for any copyright-related issues.
            </TextBlock>
          </Column>
          <Column size={8}>
            If you wish to reach our designated agent regarding copyright
            issues, please reach out to us at:
            <br />
            <br />
            OJO labs Inc.
            <br />
            Attn: OJO Designated DMCA Agent
            <br />
            1007 S Congress
            <br />
            Building 9, Suite 400
            <br />
            Austin, Texas 78704
            <br />
            512.456.8292
            <br />
            legal@ojolabs.com
          </Column>
        </Row>
      </PageWrapper>
    </>
  );
};

export default TermsAndConditionsPage;